import { HugeiconsIcon } from "@hugeicons/react";
import { Mail02Icon } from "@hugeicons-pro/core-solid-rounded";
import { Undo03Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonVariant } from "shared/components";

type EmailSentStepProps = {
  isCancelLoading: boolean;
  onCancel: () => void;
  onNext: () => void;
};

export const EmailSentStep = ({
  isCancelLoading,
  onCancel,
  onNext
}: EmailSentStepProps) => {
  return (
    <>
      <div className="flex-1 flex flex-col gap-6 items-center justify-center overflow-y-auto">
        <HugeiconsIcon
          icon={Mail02Icon}
          size={48}
          className="text-primary-500"
        />
        <div className="w-[410px] space-y-2">
          <p className="text-xl font-bold text-content-1000 text-center">
            Disclosure sent to applicant
          </p>
          <p className="text-base text-content-400 text-center">
            Reports will not run and checkout will not be available until the
            applicant signs the disclosure
          </p>
        </div>
        <Button
          variant={ButtonVariant.BASE}
          className="w-[125px]"
          HugeIcon={Undo03Icon}
          onClick={onCancel}
          loading={isCancelLoading}
        >
          Cancel
        </Button>
      </div>
      <div className="h-20 border-t border-alpha-100 bg-white gap-2 flex justify-end items-center pr-4">
        <Button
          tooltipZIndex={51}
          variant={ButtonVariant.PRIMARY}
          className="w-[125px]"
          onClick={onNext}
        >
          Continue
        </Button>
      </div>
    </>
  );
};
